import { jsx, jsxs } from 'react/jsx-runtime';
import PropTypes from 'prop-types';
import { SOURCE_ERROR, PLATFORMS_ERROR, LOCATIONS_ERROR, TYPE_VERIFICATION } from './Error.js';
import './CodeError.scss';

function CodeError({
  sourceError = "",
  platformError = "",
  locationError = "",
  typeError = "",
  externCode = "",
  isExternCode = false,
  text = ""
}) {
  const sourceUpper = SOURCE_ERROR[sourceError.toLocaleUpperCase()];
  function codeErrorMessage() {
    return `
      ${sourceUpper}${PLATFORMS_ERROR[platformError.toLocaleUpperCase()]}-${LOCATIONS_ERROR[locationError.toLocaleUpperCase()]}${TYPE_VERIFICATION(typeError.toLocaleUpperCase(), sourceUpper)}
      ${isExternCode ? `(${externCode})` : ""}
    `;
  }
  return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs("p", { className: "dtv-common-c-code-error", children: [
    text,
    " ",
    codeErrorMessage()
  ] }) });
}
CodeError.propTypes = {
  text: PropTypes.string,
  sourceError: PropTypes.string,
  platformError: PropTypes.string,
  locationError: PropTypes.string,
  typeError: PropTypes.string,
  externCode: PropTypes.string,
  isExternCode: PropTypes.bool
};

export { CodeError as default };
//# sourceMappingURL=CodeError.js.map
